export default "__VITE_ASSET__Gp7Gwjkl__"